import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Layout from "./header/Layout";
import AdminLayout from "./header/AdminLayout";
import LoginPage from "./login/LoginPage";
import {createTheme, ThemeProvider} from "@mui/material";
import OverviewPage from "./pages/OverviewPage";
import StartPage from "./pages/StartPage";
import MatrixPage from "./pages/MatrixPage";
import EmployeesPage from "./pages/EmployeesPage";
import CoursesPage from "./pages/CoursesPage";
import ApplicationPage from "./pages/ApplicationPage";
import ManagementCoursesPage from "./pages/management/ManagementCoursesPage";
import ManagementEmployeesPage from "./pages/management/ManagementEmployeesPage";
import ManagementExecutivesPage from "./pages/management/ManagementExecutivesPage";
import NoTenantPage from "./pages/NoTenantPage";
import MaintenancePage from "./pages/MaintenancePage";
import MaintenanceGuard from "./components/MaintenanceGuard";
import NoRolePage from "./pages/NoRolePage";
import AdminSelectPage from "./pages/AdminSelectPage";
import SelectAccountPage from "./pages/SelectAccountPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminTenantsPage from "./pages/admin/AdminTenantsPage";
import AdminEmployeesPage from "./pages/admin/AdminEmployeesPage";
import AuditPage from "./pages/admin/AuditPage";

const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(0,150,136)'
        },
        background: {
            default: 'gray'
        },
        secondary: {
            main: '#ffffff'
        },
        error: {
            main: 'rgb(255,0,0)'
        },
        success: {
            main: '#B6E2A1'
        },
        info: {
            main: '#d9ebd1'
        }
    }
});

function App() {
    // console.log(process.env.PUBLIC_URL);
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <MaintenanceGuard>
                <Routes>
                    <Route path={"/"} element={<Layout/>}>
                        <Route path={"/overview"} element={<OverviewPage/>}/>
                        <Route path={"/start"} element={<StartPage/>}/>
                        <Route path={"/matrix"} element={<MatrixPage/>}/>
                        <Route path={"/employees"} element={<EmployeesPage/>}/>
                        <Route path={"/courses"} element={<CoursesPage/>}/>
                        <Route path={"/management/courses"} element={<ManagementCoursesPage/>}/>
                        <Route path={"/management/employees"} element={<ManagementEmployeesPage/>}/>
                        <Route path={"/management/executives"} element={<ManagementExecutivesPage/>}/>
                        <Route path={"/application"} element={<ApplicationPage/>}/>
                    </Route>
                    <Route path={"/admin"} element={<AdminLayout/>}>
                        <Route path={"users"} element={<AdminUsersPage/>}/>
                        <Route path={"tenants"} element={<AdminTenantsPage/>}/>
                        <Route path={"employees"} element={<AdminEmployeesPage/>}/>
                        <Route path={"audit"} element={<AuditPage/>}/>
                    </Route>
                    <Route path={"/login"} element={<LoginPage/>}/>
                    <Route path={"/no-tenant"} element={<NoTenantPage/>}/>
                    <Route path={"/maintenance"} element={<MaintenancePage/>}/>
                    <Route path={"/no-role"} element={<NoRolePage/>}/>
                    <Route path={"/admin-select"} element={<AdminSelectPage/>}/>
                    <Route path={"/select-account"} element={<SelectAccountPage/>}/>
                </Routes>
                </MaintenanceGuard>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
